import { useSnackbar } from 'notistack';
import { useState, forwardRef } from "react";
// @mui
import {
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Stack,
  Fade,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// hooks
import useResponsive from '../../../hooks/useResponsive';
import useAuth from '../../../hooks/useAuth';
// utils
import Iconify from '../../../components/Iconify';
import axios from '../../../utils/axios';

// ----------

const Transition = forwardRef((props, ref) => <Fade ref={ref} {...props} />);

export default function MeetingAgainDialog({ jobPostId, candidateId, isOpen, closeDialog, meetingCount, loadData }) {
  const smUp = useResponsive('up', 'sm');
  const [next, setNext] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const { user } = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  const resetAndClose = () => {
    setNext(false);
    if (loadData) loadData();
    closeDialog();
  }

  const requestMeeting = async () => {
    try {
      setIsSubmit(true);
      const companyId = user?.employee.company[0].id;
      await axios.post(`/api/company/${companyId}/job-posts/${jobPostId}/candidate/${candidateId}/meeting-again/`);
      setNext(true);
      setIsSubmit(false);
    } catch (err) {
      setIsSubmit(false);
      enqueueSnackbar('이미 요청 하였습니다', { variant: 'info' });
      setNext(true);
      console.error(err);
    }
  }

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="xs" TransitionComponent={Transition}>
      {!next && (
      <>
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Iconify icon={"eva:alert-triangle-fill"} sx={{ width: 24, height: 24, color: 'error.main' }} />
        <Typography variant={smUp ? "h5" : "subtitle1"} gutterBottom>
          크루와 {meetingCount ? meetingCount + 1 : 2}차 미팅 진행을 협의하셨나요?
        </Typography>
        <Typography variant={smUp ? "body1" : "body2" } sx={{ wordBreak: "keep-all" }}>
          미팅때 크루와 미팅을 한번 더 하기로 협의하셨다면<br/>
          크루에게 미팅 가능시간을 요청할게요.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
        <Stack direction={{ xs: 'column-reverse', sm: 'row' }} spacing={1} sx={{ width: '100%' }} justifyContent="flex-end">
          <LoadingButton
            onClick={closeDialog}
            size="large"
            sx={{ px: 4 }}
            fullWidth={!smUp}
            loading={isSubmit}
          >
            돌아가기
          </LoadingButton>
          <LoadingButton
            variant="contained"
            onClick={requestMeeting}
            size="large"
            sx={{ px: 4 }}
            fullWidth={!smUp}
            loading={isSubmit}
          >
            {meetingCount ? meetingCount + 1 : 2}차 미팅을 하기로 했어요
          </LoadingButton>
        </Stack>
      </DialogActions>
      </>
      )}
      {next && (
      <>
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Iconify icon={"eva:info-fill"} sx={{ width: 24, height: 24, color: 'info.main' }} />
        <Typography variant={smUp ? "h5" : "subtitle1"} gutterBottom>
          크루의 미팅 가능 시간을 요청했어요.
        </Typography>
        <Typography variant={smUp ? "body1" : "body2" } sx={{ wordBreak: "keep-all" }}>
          크루가 미팅 가능한 시간을 확정하면 카카오톡으로 알려드릴게요. 그다음 미팅을 잡아주세요.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
        <Stack direction={{ xs: 'column-reverse', sm: 'row' }} spacing={1} sx={{ width: '100%' }} justifyContent="flex-end">
          <Button
            variant="contained"
            onClick={resetAndClose}
            size="large"
            sx={{ px: 4 }}
            fullWidth={!smUp}
          >
            확인했어요
          </Button>
        </Stack>
      </DialogActions>
      </>
      )}
    </Dialog>
  )
};
